<template>
  <div class="q-mx-sm-48 q-my-16">
    <q-btn
      class="full-width-sm"
      color="positive"
      :href="link"
      :label="$t('button.get_offers')"
      icon-right="open_in_new"
      target="_blank"
      @click="$emit('click')"
    />
    <q-card
      class="q-mt-16 q-px-16 q-py-12"
      bordered
      flat
    >
      <div class="flex no-wrap items-center">
        <q-icon
          name="img:common/icons/percent.svg"
          size="24px"
          left
        />
        <div>
          <div class="fs-14 text-bold">{{ $t(`partners.find.${isCarRental ? 'car_rental' : 'experience'}`) }}</div>
          <div class="fs-12">{{ $t('partners.enjoy_discount', { discount: isCarRental ? 5 : 15 }) }}</div>
        </div>
      </div>
      <div class="q-mt-12 text-center">
        <q-chip
          class="border-radius-8"
          color="grey-2"
          size="16px"
          clickable
          @click="copyToClipboard(promoCode)"
        >
          {{ $t('label.promo_code') }}
          <b class="q-mx-8">{{ promoCode }}</b>
          <q-icon
            size="18px"
            color="primary"
            name="content_copy"
          />
        </q-chip>
      </div>
    </q-card>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import useCopyToClipboard from '~composables/useCopyToClipboard';

const props = defineProps({
  isCarRental: {
    type: Boolean,
    default: false,
  },
  transfer: {
    type: Object,
    required: true,
  },
});

defineEmits(['click']);

const { copyToClipboard } = useCopyToClipboard();

const link = computed(() => {
  if (props.isCarRental) {
    const query = new URLSearchParams({
      utm_source: 'gtr-main',
      utm_medium: 'tab',
      utm_campaign: 'promo',
      utm_content: 'button',
    });

    if (props.transfer.from.name) {
      query.append('pickup[location]', props.transfer.from.name);
    }

    return `https://getrentacar.com/search?${query}`;
  }

  let href = 'https://getexperience.com/';
  let params = {
    utm_campaign: 'partner_name:gettransfer|camp_name:loc_tab_convertion_button|type:in_app',
    utm_content: 'button',
    utm_medium: 'partner',
    utm_source: 'gettransfer',
  };

  if (props.transfer.from.place_id) {
    href += 'experiences';
    params = {
      ...params,
      googlePlaceId: props.transfer.from.place_id,
      realm: 'person',
      searchResult: 'true',
    };
  }

  return `${href}?${new URLSearchParams(params)}`;
});

const promoCode = computed(() => (props.isCarRental ? 'GTR5' : 'FUNWITHGEXP15'));
</script>
